module.exports = __webpack_public_path__ + "static/business-design-4c5544e71d56b6cbe366d1030f8223da.png";